<template>
  <bottom-sheet
    :visible="visible"
    :close-icon-right-align="true"
    :maxWidth="'max-w-[400px]'"
    @close="$emit('close')"
  >
    <div class="mx-1">
      <span
        class="-mt-5 mb-4 flex w-max cursor-pointer text-left text-neutral-subtle"
        @click="handleResetSort"
      >
        Reset
      </span>
      <h4 class="text-left text-2xl text-dark-blue">Sort by</h4>

      <div v-if="isLoadsDashboard">
        <round-radio-button
          name="sort"
          value="rpm"
          :show="true"
          :checked="selectedSort === 'rpm'"
          :handle-click="($event) => handleSelectSort($event, 'rpm')"
        >
          <p
            class="mr-2 text-1md"
            :class="{ 'text-dark-gray': selectedSort === 'rpm' }"
          >
            RPM
          </p>
          <img
            class="scale-y-[-1] transform"
            src="@/assets/arrow-down-gray.svg"
            alt="down icon"
          />
        </round-radio-button>
        <round-radio-button
          name="sort"
          value="age"
          :show="true"
          :checked="selectedSort === 'posting_desc'"
          :handle-click="($event) => handleSelectSort($event, 'posting_desc')"
        >
          <p
            class="mr-2 text-1md"
            :class="{ 'text-dark-gray': selectedSort === 'rpm' }"
          >
            Age
          </p>
          <img
            src="@/assets/arrow-down-gray.svg"
            alt="down icon"
          />
        </round-radio-button>
        <round-radio-button
          name="sort"
          value="price_desc"
          :show="true"
          :checked="selectedSort === 'price_desc'"
          :handle-click="($event) => handleSelectSort($event, 'price_desc')"
        >
          <p
            class="mr-2 text-1md"
            :class="{ 'text-dark-gray': selectedSort === 'rpm' }"
          >
            Price
          </p>
          <img
            class="scale-y-[-1] transform"
            src="@/assets/arrow-down-gray.svg"
            alt="down icon"
          />
        </round-radio-button>
        <round-radio-button
          name="sort"
          value="price_asc"
          :show="true"
          :checked="selectedSort === 'price_asc'"
          :handle-click="($event) => handleSelectSort($event, 'price_asc')"
        >
          <p
            class="mr-2 text-1md"
            :class="{ 'text-dark-gray': selectedSort === 'rpm' }"
          >
            Price
          </p>
          <img
            src="@/assets/arrow-down-gray.svg"
            alt="down icon"
          />
        </round-radio-button>
        <round-radio-button
          name="sort"
          value="distance_asc"
          :show="true"
          :checked="selectedSort === 'distance_asc'"
          :handle-click="($event) => handleSelectSort($event, 'distance_asc')"
        >
          <p
            class="mr-2 text-1md"
            :class="{ 'text-dark-gray': selectedSort === 'rpm' }"
          >
            Distance
          </p>
          <img
            class="scale-y-[-1] transform"
            src="@/assets/arrow-down-gray.svg"
            alt="down icon"
          />
        </round-radio-button>
        <round-radio-button
          name="sort"
          value="distance_desc"
          :show="true"
          :checked="selectedSort === 'distance_desc'"
          :handle-click="($event) => handleSelectSort($event, 'distance_desc')"
        >
          <p
            class="mr-2 text-1md"
            :class="{ 'text-dark-gray': selectedSort === 'rpm' }"
          >
            Distance
          </p>
          <img
            src="@/assets/arrow-down-gray.svg"
            alt="down icon"
          />
        </round-radio-button>
        <!-- <round-radio-button
          item="Deadhead (Shortest mileage from pickup)"
          name="sort"
          value="deadhead"
          :show="true"
          :checked="selectedSort === 'deadhead'"
          :handle-click="($event) => handleSelectSort($event, 'deadhead')"
        /> -->
      </div>

      <div v-else>
        <round-radio-button
          item="Origin"
          name="sort"
          value="origin"
          :show="true"
          :checked="selectedSort === 'origin'"
          :handle-click="($event) => handleSelectSort($event, 'origin')"
        />
        <round-radio-button
          item="Destination"
          name="sort"
          value="destination"
          :show="true"
          :checked="selectedSort === 'destination'"
          :handle-click="($event) => handleSelectSort($event, 'destination')"
        />
      </div>

      <button-main
        class="mb-2 mt-4 text-1md"
        :disabled="!selectedSort"
        @click="handleApplySort"
      >
        Apply
      </button-main>
    </div>
  </bottom-sheet>
</template>

<script>
import { ref, onBeforeMount } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import BottomSheet from '@/components/BottomSheet.vue';
import RoundRadioButton from '@/components/RoundRadioButtonLoads.vue';
import ButtonMain from '@/components/Button.vue';

export default {
  name: 'LoadSortBottomSheet',
  components: {
    BottomSheet,
    RoundRadioButton,
    ButtonMain,
  },
  props: {
    visible: Boolean,
    isLoadsDashboard: Boolean,
  },
  emits: ['close'],
  setup(_, { emit }) {
    const store = useStore();
    const router = useRouter();

    const selectedSort = ref('');

    onBeforeMount(() => {
      const querySort = router.currentRoute.value.query?.sort;

      if (querySort) {
        selectedSort.value = querySort;
      }
    });

    const handleSelectSort = (item, value) => {
      selectedSort.value = value;
    };

    const handleResetSort = () => {
      selectedSort.value = '';
      const existingSort = router.currentRoute.value.query?.sort;
      const existingQueries = router.currentRoute.value.query;

      // eslint-disable-next-line no-unused-vars
      const { sort, ...rest } = existingQueries || {};

      if (existingSort) {
        router.push({
          query: {
            ...rest,
          },
        });
      }

      emit('close');
    };

    const handleApplySort = () => {
      // getLoads request either here or in watch func in /MyLoads
      const existingSort = router.currentRoute.value.query?.sort;
      const existingQueries = router.currentRoute.value.query;
      console.log('existing', existingSort, '/', selectedSort.value);

      if (existingSort !== selectedSort.value) {
        store.commit('loads/setLoading', true);

        router.push({
          query: {
            // page: 1,
            ...existingQueries,
            sort: selectedSort.value,
          },
        });
      }

      emit('close');
    };
    return {
      selectedSort,
      handleResetSort,
      handleApplySort,
      handleSelectSort,
    };
  },
};
</script>
